import React from "react";
import { Navigate } from "react-router-dom";
import LogoutTimer from "./LogoutTimer";
import RefreshToken from "./RefreshToken";

export const AdminProtectedRoute = ({ children }) => {
    const temp = localStorage.getItem("name");

    // if (!temp || temp === null || undefined) {
    //     return <Navigate to="/signin" />;
    // }

    return <>{children}
       <LogoutTimer />
       <RefreshToken />
    </>;
};

export default AdminProtectedRoute;
